import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import { getProductData } from '@elem/utils/getProductData';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import EcoTab from 'eco-design/elements/eco-tab';
import ProductNav from '../../common/ProductNav';
import { generalKey, productPageTheme, generalKey_US, generalKey_PH } from '../../config/pageConfig';
import { useGlobal } from '@/utils/useGlobal';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import './index.scss';

export default function ExampleProductA() {
    const { gloproductlist } = useGlobal();
    const { locale = 'us' } = useRouter();
    const IS_US: boolean = ['us', 'ca'].includes(locale);
    const IS_PH: boolean = ['ph'].includes(locale);
    let keys = generalKey;
    if (IS_US) {
        keys = generalKey_US;
    } else if (IS_PH) {
        keys = generalKey_PH;
    }
    const [productDataArr, setProductDataArr] = useState<any>([]);
    useEffect(() => {
        const getProductDataHandle = async () => {
            const promises = keys.map(async (key) => {
                const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: key });
                const productPageData = await getProductData(productMsg, locale, productMsg?.spuId || productMsg?.sourceId);
                return productPageData;
            });
            const result = await Promise.all(promises);
            setProductDataArr(result);
        };
        getProductDataHandle();
    }, []);

    const [supportData, setSupportData] = useState(null);
    const [spuId, setSpuId] = useState('');
    const handleTabChange = (tab: any, k: number) => {
        setSupportData(productDataArr[k]?.supportData);
        setSpuId(tab?.typeValue);
    };
    useEffect(() => {
        setSupportData(productDataArr?.[0]?.supportData);
        setSpuId(productDataArr[0]?.productDetail?.spuId);
    }, [productDataArr]);

    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: keys[0] });
    return (
        <>
            <ProductNav activeTab={'Support'} buyLink={productMsg.buyLink} />
            {productDataArr?.length > 1 && (
                <div className="tab-sticky-box">
                    <div className="tab-wrapper">
                        <EcoTab
                            items={productDataArr?.map((data: any) => ({ typeValue: data?.productDetail?.spuId, tabLabel: data?.productDetail?.name }))}
                            activeType={productDataArr[0]?.productDetail?.spuId}
                            onChange={handleTabChange}
                            theme="black"
                        />
                    </div>
                </div>
            )}
            {supportData && spuId && <ProductSupport supportData={supportData} theme={productPageTheme} spuId={spuId} />}
        </>
    );
}
